import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import { Helmet } from 'react-helmet';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import InfoPage from './containers/InfoPage';
import LandingPage from './containers/LandingPage/index';
import Store from './store/lang';
import './stylesheets/global.scss';

ReactGA.initialize('G-L997LXLF8F');

const tagManagerArgs = {
  gtmId: 'GTM-WVFPW42',
};
TagManager.initialize(tagManagerArgs);

function App() {
  const color = {
    primary: '#0973B9',
    secondary: '#2A9D8F',
    third: '#E2B23A',
    fourth: '#D42838',
    textPrimary: '#404041',
    textSecondary: '#707070',
    shadow: 'rgba(0,79,206, 0.2)',
  };

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1200,
        xl: 1920,
      },
    },
    overrides: {
      MuiButton: {
        root: {
          borderRadius: '2rem',
          textTransform: 'initial',
          padding: '8px 24px !important',
          fontSize: '1rem',
          '& img': {
            width: '24px',
          },
          '&$disabled': {
            color: `${color.primary} !important`,
            borderColor: `${color.primary} !important`,
          },
        },
      },
      MuiPaper: {
        root: {
          borderRadius: '6px !important',
        },
        elevation1: {
          boxShadow: `0 2px 4px ${color.shadow} !important`,
        },
        elevation2: {
          boxShadow: `0 8px 16px ${color.shadow} !important`,
        },
      },
      MuiDrawer: {
        paper: {
          borderRadius: '0 !important',
        },
      },
    },
    palette: {
      primary: {
        main: color.primary,
      },
      secondary: {
        main: color.secondary,
      },
    },
  });
  return (
    <Store>
      <ThemeProvider theme={theme}>
        <Helmet>
          <style type="text/css">{`
        .color-primary {
          color: ${color.primary} !important
        }
    `}</style>
        </Helmet>
        <Router>
          <Header />

          <Switch>
            <Route path="/info/:lang" exact component={InfoPage} />
            <Route path="/:lang" exact component={LandingPage} />
            <Redirect to="/en" />
          </Switch>

          <Footer />
        </Router>
      </ThemeProvider>
    </Store>
  );
}

export default App;
